// import home from '@assets/home.png';
import homeForGently from '@assets/home_for_ge.png';
import { LoginPanel } from '@components';
import { useSelector, useDispatch } from 'react-redux';
import SeelLogo from '@assets/seel_logo.svg';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { submit } from '@components/login-panel/hooks';
import { useQuery, useBehaviorData } from '@hooks';
import { NO_EMAIL_CHANNEL, PLATFORM_NAME, SUPPORT_SIGNATURE_TO_LOGIN } from '@constants';
import classes from './index.module.css';

// const TITLE_NORMAL = 'Resolve issues with';
const TITLE_SEEL = 'Seel';
const TITLE_FOR_GENTLY = 'Gently returns';

export const Login = () => {
  const { platform } = useSelector((state) => state.policy);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setReportData = useBehaviorData();

  const { query: { order_number: orderNumber, email, signature } } = useQuery();
  const resolve = async () => {
    await submit({
      orderId: orderNumber,
      email,
      navigate,
      dispatch,
      // policyType: 'DHGATE_BP',
      setReportData,
      platform,
      signature,
    });
  };

  useEffect(() => {
    // dhlink shoplazza 不用登录 直接跳转到options页面
    if (platform && NO_EMAIL_CHANNEL.includes(platform) && orderNumber) {
      resolve();
    }
    // SUPPORT_SIGNATURE_TO_LOGIN中的平台 需要增加用signature登录，故其有两种登录形式，一种普通的email&orderNumber，一种是orderNumber&signature登录
    if (platform && SUPPORT_SIGNATURE_TO_LOGIN.includes(platform) && orderNumber && signature && !email) {
      resolve();
    }
  }, [platform]);

  return (
    <div className={classes.content}>
      <section className={classes.left_part}>
        {
          platform === PLATFORM_NAME.GENTLY ? (
            <section className={classes.title_for_gently}>
              <section>
                {TITLE_FOR_GENTLY}
              </section>
              <section className={classes.title_powered}>
                POWERED BY
                {' '}
                <img src={SeelLogo} alt="" className={classes.powered_seel} />

                {/* <span className={classes.powered_seel}>{TITLE_SEEL}</span> */}
              </section>
            </section>
          ) : (
            <section className={classes.title}>
              Resolve issues
              <br />
              with
              <span className={classes.title_seel}>
                {TITLE_SEEL}
                {/* <span className={classes.title_block}></span> */}
              </span>
            </section>
          )
        }
        <section>
          <img src={platform === PLATFORM_NAME.GENTLY ? homeForGently : 'https://resolution.seel.com/static-resource/images/login.png'} className={classes.home_icon} alt="" />
        </section>
      </section>
      <LoginPanel />
    </div>
  );
};
